import { Col, Form, Row } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

import { Formik } from 'formik';

import { CdrsReportFilter } from '@components/Reports/Cdrs/CdrsReportFilter';
import { CdrsReportTable } from '@components/Reports/Cdrs/CdrsReportTable';
import { reportsApi } from '@reducers/reports/reports';

export const Cdrs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  return (
    <Formik
      enableReinitialize
      initialValues={{
        country: searchParams.get('country') || '',
        area: searchParams.get('area') || '',
        startDate: searchParams.get('startDate') || '',
        startDateTime: searchParams.get('startDateTime') || '',
        endDate: searchParams.get('endDate') || '',
        endDateTime: searchParams.get('endDateTime') || '',
        completed: searchParams.get('completed') || '',
        trafficType: searchParams.get('trafficType') || '',
        destination: searchParams.get('destination') || '',
      }}
      onSubmit={() => {}}
    >
      <Form as={Row}>
        <Col md={3}>
          <CdrsReportFilter
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
        </Col>
        <Col md={9}>
          <CdrsReportTable useData={reportsApi.useGetPcdrsQuery} />
        </Col>
      </Form>
    </Formik>
  );
};
